import { render, staticRenderFns } from "./AddTodo.vue?vue&type=template&id=012715a2&scoped=true"
import script from "./AddTodo.vue?vue&type=script&lang=js"
export * from "./AddTodo.vue?vue&type=script&lang=js"
import style0 from "./AddTodo.vue?vue&type=style&index=0&id=012715a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012715a2",
  null
  
)

export default component.exports